<ul class="h-100 nav flex-column text-medium-font border-1">
    <li *ngIf="showCloseButton" class="mr-2 my-2 nav-item">
        <a href="javascript:void(0)" (click)="closeMenu()" class="nav-link">
            <i class="fas fa-arrow-left mr-2"></i>
            {{ 'action.close' | translate }}
        </a>
    </li>
    <div *ngIf="!showCloseButton" class="w-50 ml-4 image-holder mt-5 mb-5 justify-content-center">
        <img src="/assets/images/givt-logo.svg" />
    </div>
    <li class="mr-2 my-2 nav-item">
        <div class="d-flex justify-content-between align-items-center">
            <a [ngClass]="{ 'active': isDashboardActive }" class="text-givt-purple nav-link"
                (click)="dashboardClicked()" translate>
                <i class="fas fa-th-large fa-lg mr-2"></i>
                action.goToDashboard
            </a>
            <a *ngIf="shouldShowSwitchButton" class="text-givt-purple nav-link" (click)="switchDashboardClicked()">
                <div class="switch-button pl-1 pr-1 rounded">
                    <small translate class="mr-1"><i class="fas fa-exchange-alt ml-1"></i>
                        sideBarComponent.switchDashboard
                    </small>
                </div>
            </a>
        </div>
    </li>
    <li *ngIf="currentCollectGroup == null" class="mr-2 my-2 nav-item">
        <a class="nav-link text-givt-purple" [ngClass]="{ 'active': isUsersActive }" (click)="usersClicked()"
            [routerLink]="['/','dashboard','root', { outlets: { 'dashboard-outlet': ['users'] } }]"
            queryParamsHandling="merge" translate>
            <i class="fas fa-users fa-lg mr-2"></i>
            sideBarComponent.users
        </a>
    </li>
    <li class="mr-2 my-2 nav-item">
        <a (click)="logOut()" class="nav-link text-muted" href="javascript:void(0)">
            <i class="fas fa-sign-out-alt mr-2"></i>
            {{ 'action.signOut' | translate }}
        </a>
    </li>
    <li class="text-size-small text-givt-purple d-flex mx-3 my-2 flex-grow-1 align-items-end givt-essentials">
        &copy; Givt Inc. {{startYear}}-{{ now | date: 'YYYY'}} <br>
        <a translate target="_blank" rel="noreferrer noopener"
            href="{{privacyLink}}">sideBarComponent.privacyStatement</a> <br>
        <a translate target="_blank" rel="noreferrer noopener" href="{{termsLink}}">sideBarComponent.termsAndPricing</a>
        <br />
    </li>
</ul>